export default __webpack_public_path__ + "static/media/toplu_kullanici_ekle_ornek.648a6316.xlsx";